import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MobileMenu from './MobileMenu';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header id="t-header" className="t-records">
      <div id="rec814555075" className="r t-rec t-rec_pb_0" style={{paddingBottom: '0px'}}>
        <div id="nav814555075marker"></div>
        <div className="tmenu-mobile">
          <div className="tmenu-mobile__container">
            <div className="tmenu-mobile__burgerlogo">
              <Link to="/">
                <img
                  src="/images/ozarkselec-logo-bleu.png"
                  className="tmenu-mobile__imglogo"
                  style={{minWidth: '150px'}}
                  alt="OZARKS"
                />
              </Link>
            </div>
            <button 
              type="button"
              className={`t-menuburger ${isMobileMenuOpen ? 'active' : ''}`}
              aria-label="Navigation menu"
              aria-expanded={isMobileMenuOpen}
              onClick={toggleMobileMenu}
            >
              <span style={{backgroundColor: 'var(--ozarks-blue-dark)'}}></span>
              <span style={{backgroundColor: 'var(--ozarks-blue-dark)'}}></span>
              <span style={{backgroundColor: 'var(--ozarks-blue-dark)'}}></span>
            </button>
          </div>
        </div>
        
        <div 
          id="nav814555075" 
          className="t228 t228__positionabsolute tmenu-mobile__menucontent_hidden"
          style={{
            backgroundColor: 'var(--ozarks-white)',
            height: '110px'
          }}
        >
          <div className="t228__maincontainer t228__c12collumns" style={{height: '110px'}}>
            <div className="t228__padding40px"></div>
            <div className="t228__leftside">
              <div className="t228__leftcontainer">
                <Link to="/" className="t228__imgwrapper">
                  <img 
                    className="t228__imglogo"
                    src="/images/ozarkselec-logo-bleu.png"
                    style={{maxHeight: '80px'}} 
                    alt="OZARKS"
                  />
                </Link>
              </div>
            </div>
            <div className="t228__centerside">
              <nav className="t228__centercontainer">
                <ul className="t228__list t-menu__list t228__list_hidden">
                  <li className="t228__list_item" style={{padding: '0 20px 0 0'}}>
                    <Link className="t-menu__link-item" to="/rse">
                      RSE
                    </Link>
                  </li>
                  <li className="t228__list_item" style={{padding: '0 0 0 20px'}}>
                    <Link className="t-menu__link-item" to="/contact">
                      Contacts
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="t228__rightside">
              <div className="t228__rightcontainer">
                <div className="t228__right_descr">
                  📱+33 630 98 45 78<br />
                  ⏰ Lun. – Ven. / 8:00–19:00
                </div>
                <div className="t-sociallinks">
                  <ul className="t-sociallinks__wrapper" aria-label="Social media links">
                    <li className="t-sociallinks__item t-sociallinks__item_facebook">
                      <a 
                        href="https://www.facebook.com/profile.php?id=61555968326960" 
                        target="_blank" 
                        rel="nofollow noreferrer" 
                        aria-label="Ozarkselec" 
                        title="Ozarkselec" 
                        style={{width: '30px', height: '30px'}}
                      >
                        <svg className="t-sociallinks__svg" role="presentation" width="30px" height="30px" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M50 100c27.6142 0 50-22.3858 50-50S77.6142 0 50 0 0 22.3858 0 50s22.3858 50 50 50Zm3.431-73.9854c-2.5161.0701-5.171.6758-7.0464 2.4577-1.5488 1.4326-2.329 3.5177-2.5044 5.602-.0534 1.4908-.0458 2.9855-.0382 4.4796.0058 1.1205.0115 2.2407-.0085 3.3587-.6888.005-1.3797.0036-2.0709.0021-.9218-.0019-1.8441-.0038-2.7626.0096 0 .8921.0013 1.7855.0026 2.6797.0026 1.791.0052 3.5853-.0026 5.3799.9185.0134 1.8409.0115 2.7627.0096.6912-.0015 1.382-.0029 2.0708.0021.0155 3.5565.0127 7.1128.0098 10.669-.0036 4.4452-.0072 8.8903.0252 13.3354 1.8903-.0134 3.7765-.0115 5.6633-.0095 1.4152.0014 2.8306.0028 4.2484-.0022.0117-4.0009.0088-7.9986.0058-11.9963-.0029-3.9979-.0058-7.9957.0059-11.9964.9533-.005 1.9067-.0036 2.86-.0021 1.2713.0019 2.5425.0038 3.8137-.0096.396-2.679.7335-5.3814.9198-8.0947-1.2576-.0058-2.5155-.0058-3.7734-.0058-1.2578 0-2.5157 0-3.7734-.0059 0-.4689-.0007-.9378-.0014-1.4066-.0022-1.4063-.0044-2.8123.0131-4.2188.198-1.0834 1.3158-1.9104 2.3992-1.8403h5.1476c.0117-2.8069.0117-5.602 0-8.4089-.6636 0-1.3273-.0007-1.9911-.0014-1.9915-.0022-3.9832-.0044-5.975.0131Z" fill="var(--ozarks-blue-dark)"/>
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="t228__padding40px"></div>
          </div>
        </div>
        
        <MobileMenu 
          isOpen={isMobileMenuOpen} 
          onClose={() => setIsMobileMenuOpen(false)} 
        />
      </div>
    </header>
  );
};

export default Header;